import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

export default function ShippingSpeedEstimatedDeliveryDate(
  { estimatedDeliveryDateDisplay, className, dataTestId },
) {
  return (
    <span data-testid={dataTestId} className={clsx('shipping-option-edd', className)}>
      {estimatedDeliveryDateDisplay}
    </span>
  );
}

ShippingSpeedEstimatedDeliveryDate.defaultProps = {
  estimatedDeliveryDateDisplay: undefined,
  className: undefined,
  dataTestId: undefined,
};

ShippingSpeedEstimatedDeliveryDate.propTypes = {
  estimatedDeliveryDateDisplay: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};
